import { scrollToY } from '../utils/index'

export default class scrollToTop {
  constructor (el) {
    el.addEventListener('click', e => {
      e.preventDefault()
      scrollToY(0)
    })
  }
}
